
// const appUrl= '//casino.tecpiniondev.com/';
// const apiUrl= '//casino.tecpiniondev.com/api';

// const appUrl= 'https://slotngo.com/';
// const apiUrl= 'https://slotngo.com/api';

// const appUrl= 'https://casino.tecpiniondev.com/';
// const apiUrl= 'https://casino.tecpiniondev.com/api';
 
// const appUrl = 'https://slotngo.com/';
// const apiUrl = 'https://api.slotngo.com/api';

const appUrl= 'https://casinonewapi.tecpiniondev.com/';
const apiUrl= 'https://casinonewapi.tecpiniondev.com/api';

// const appUrl= 'http://127.0.0.1:8000/';
// const apiUrl= 'http://127.0.0.1:8000/api';

const cashierKey ="bb4af6ee-452a-42cc-9b0b-a0c64504175a";


// const appUrl= '';
// const apiUrl= 'api';  

const config = {
    site: {
        appUrl: appUrl,
        apiUrl: apiUrl,
        cashierKey: cashierKey,
        appName: 'Sportsbook',
        appLogo: './app/assets/images/logo-dark.png',
        logoSm: './app/assets/images/logo.png',
        logoLight: './app/assets/images/logo.png',
        buttonbg: './app/assets/images/Group16@2x.png',
        bg: './app/assets/images/1624@2x.png'
    },
    admin:{
        appUrl: appUrl,
        apiUrl: apiUrl,
        appName: 'My App',
        appLogo: './admin-app/assets/imagesimages/logo-dark.png',
        logoSm: './admin-app/assets/images/logo-sm.png',
        logoLight: './admin-app/assets/images/logo-light.png',
        error404: './admin-app/assets/images/error.png',
        // assetUrl: 'http://sportsbook.demo/assets/admin/',
        assetsUrl: function (itemPath) {
            return appUrl+'/assets/admin/'+ itemPath;
        }
    }
};
export default config;